export enum ActivityTableType {
  Expired = "expired",
  Today = "today",
  Future = "future",
}
